<div class="pagingContainer">
    <button [disabled]="currentPage < 1" (click)="PreviousPage()">< Previous {{currentPage < 1 ? "" : recordsPerPage}}</button>

    <span class="separator"></span>

    <button [disabled]="GetNextRecordsCount() < 1"
            (click)="NextPage()">
        {{GetNextRecordsCount() > recordsPerPage ?  "Next " + recordsPerPage :  "Last " + (GetNextRecordsCount() < 1 ? "" : GetNextRecordsCount()) }} >
    </button>
</div>
